import i18n from './index';

/** Returns generated legacy portal copy from locale resources. */
export function portalCopy(key: string, values?: Record<string, unknown>): string {
  return i18n.t(`generatedPortalCopy.${key}`, values);
}
